<template>
  <div class="page-container announcement-bar-form">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar anuncio" : "Nuevo anuncio" }}
      </h1>
    </div>
    <div class="container px-0">
      <div class="row justify-content-center">
        <div class="col-12">
          <b-card tag="article" no-body style="max-width: 640px" class="custom-card">
            <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
              <h3>
                {{ editing ? "Datos del anuncio" : "Datos del anuncio" }}
              </h3>
            </b-card-header>
            <b-card-body class="custom-card-body px-0 pb-0">
              <form class="custom-form" @submit.prevent="save" novalidate>
                <div class="form-section py-0 border-0">
                  <h2 class="custom-card-subtitle">Información general</h2>

                  <p class="custom-card-description">
                    Ingresa los datos del nuevo anuncio
                  </p>

                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="text">Texto *</label>
                        <textarea id="text" maxlength="50" placeholder="Escriba aquí" class="custom-form-control"
                          :class="{
                            'custom-form-control-error':
                              $v.form.text.$error && !$v.form.text.required,
                          }" v-model="form.text"></textarea>
                        <p class="my-0 small text-right">Total: {{ form.text.length }}/50 max. caracteres</p>
                        <!-- <FormInput
                          id="text"
                          type="text"
                          placeholder="Ingresar tex"
                          maxlength="150"
                          :show-error="
                            ($v.form.text.$error &&
                              !$v.form.text.required) ||
                            ($v.form.text.$error &&
                              !$v.form.text.maxLength)
                          "
                          v-model="form.text"
                        /> -->
                        <form-error message="Texto es requerido"
                          v-if="$v.form.text.$error && !$v.form.text.required"></form-error>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="redirectType">Redireccionar a</label>

                        <FormSelect id="redirectType" v-model="form.redirectType" :items="redirectTypes"
                          defaultOption="Sin redirección" @change="form.redirectUrl = null" />
                      </div>

                      <div class="form-group" v-if="
                        form.redirectType ===
                        LocalConstants.BannersRedirectTypes.CATEGORY.key
                      ">
                        <label for="redirectType">Categoría</label>

                        <FormSelect id="redirectType" v-model="form.redirectUrl" :items="categories"
                          defaultOption="Elegir categoría" :show-error="$v.form.redirectUrl.$error &&
                            !$v.form.redirectUrl.required
                            " />

                        <form-error message="Categoría es requerido" v-if="
                          $v.form.redirectUrl.$error &&
                          !$v.form.redirectUrl.required
                        "></form-error>
                      </div>

                      <div class="form-group" v-if="
                        form.redirectType ===
                        LocalConstants.BannersRedirectTypes.PRODUCT.key
                      ">
                        <label for="redirectType">Producto</label>

                        <FormSelect id="redirectType" v-model="form.redirectUrl" :items="products"
                          defaultOption="Elegir producto" :show-error="$v.form.redirectUrl.$error &&
                            !$v.form.redirectUrl.required
                            " />

                        <form-error message="Producto es requerido" v-if="
                          $v.form.redirectUrl.$error &&
                          !$v.form.redirectUrl.required
                        "></form-error>
                      </div>

                      <div class="form-group" v-if="
                        form.redirectType ===
                        LocalConstants.BannersRedirectTypes.OTHER.key
                      ">
                        <label for="redirectType">Otra URL</label>

                        <FormInput type="text" placeholder="Ingresar URL" v-model="form.redirectUrl" :show-error="$v.form.redirectUrl.$error &&
                          !$v.form.redirectUrl.required
                          " />

                        <form-error message="URL es requerido" v-if="
                          $v.form.redirectUrl.$error &&
                          !$v.form.redirectUrl.required
                        "></form-error>

                        <b-form-checkbox v-model="form.openNewTab" class="mt-2">
                          <span class="custom-checkbox-label">Abrir en una ventana nueva</span>
                        </b-form-checkbox>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group mb-0 d-flex">
                        <div class="color-field-container">
                          <label for="to" class="mb-0">Color fondo </label>
                          <p class="label-description m-0">Selecciona un color o ingresa un código HEX.</p>
                        </div>

                        <FormColorPicker v-model="form.backgroundColor" />
                      </div>
                      <form-error message="Color de fondo es requerido"
                        v-if="$v.form.backgroundColor.$error && !$v.form.backgroundColor.required"></form-error>
                    </div>
                  </div>
                </div>

                <div class="form-section border-0 pt-0">
                  <div class="form-group-buttons text-right">
                    <router-link :to="{ name: 'tools-announcement-bar-list' }" class="button button-light">
                      {{ editing ? "Volver" : "Cancelar" }}
                    </router-link>
                    <button class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </form>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import {
  Alert,
  Constants,
  FormError,
  FormSelect,
  FormInput,
  FormColorPicker,
} from "@wizepe/wize-admin";

import { required, requiredIf } from "vuelidate/lib/validators";

import { AnnouncementBarService, ProductService } from "@/core/services";

import { Constants as LocalConstants } from "@/core/utils";

export default {
  data() {
    return {
      form: {
        redirectType: null,
        text: '',
        backgroundColor: null,
        redirectUrl: null,
        openNewTab: false
      },
      redirectTypes: [
        LocalConstants.BannersRedirectTypes.CATEGORY,
        LocalConstants.BannersRedirectTypes.PRODUCT,
        LocalConstants.BannersRedirectTypes.OTHER,
      ],
      editing: false,
      disableTo: false,
      categories: [],
      products: [],
      LocalConstants,
    };
  },
  components: {
    FormError,
    FormInput,
    FormSelect,
    FormColorPicker,
  },
  validations: {
    form: {
      // redirectType sin validación: la redirección es opcional
      text: { required },
      backgroundColor: { required },
      redirectUrl: {
        required: requiredIf((model) => {
          return model.redirectType;
        }),
      }
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },
  async mounted() {
    await this.$store.dispatch("app/loadCategories");
    this.initialize();
    await this.getProducts();
  },
  methods: {
    async getIdByTypeUrl() {
      let type = this.form.redirectType;
      let list = [];

      if (type == this.LocalConstants.BannersRedirectTypes.CATEGORY.key) {
        // Buscar el slug en categorías
        list = this.categories;
      } else if (type == this.LocalConstants.BannersRedirectTypes.PRODUCT.key) {
        // Buscar el slug en productos
        list = this.products;
      }

      let item = list.find((item) => item.slug == this.form.redirectUrl);
      if (item) this.form.redirectUrl = `${item.key}`;
    },
    initialize() {
      this.categories = this.categoriesList.map((c) => ({
        key: c.slug,
        label: c.name,
      }));
    },
    async getProducts() {
      try {
        const response = await ProductService.listAll();
        this.products = response.payload.map((item) => {
          return {
            key: item.id,
            label: item.name,
            slug: item.slug,
          };
        });
      } catch (error) {
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async save() {
      this.$v.$touch();

      if (this.$v.$error) {
        this.$nextTick(() => {
          const firstError = document.querySelector(".form-error");
          // Sin mensaje visible, $smoothScroll(null) lanza TypeError (nodeName)
          if (firstError) {
            this.$smoothScroll({
              scrollTo: firstError,
              updateHistory: false,
              offset: -50,
            });
          }
        });
        return;
      }

      this.$store.dispatch("app/loading", true);

      const data = {
        ...this.form,
      };

      // Sin redirección: se guarda sin destino
      if (!data.redirectType) {
        data.redirectType = null;
        data.redirectUrl = null;
        data.objectId = null;
        data.openNewTab = false;
      }

      try {
        let response;
        if (!this.editing) {
          response = await AnnouncementBarService.save(data);
        } else {
          response = await AnnouncementBarService.update(this.$route.params.id, data);
        }

        if (response.status == "OK") {
          Alert.success("Se almacenó la información correctamente");
          if (!this.editing) {
            this.$router.push({
              name: "tools-announcement-bar-list",
              params: { id: response.payload.id },
            });
            this.editing = true;
          }
        } else {
          Alert.error("No se pudo guardar el anuncio, por favor inténtelo nuevamente.");
        }
      } catch (ex) {
        console.error(ex);
        Alert.error((ex && ex.errors && ex.errors.message) || ex);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await AnnouncementBarService.get(id);

        this.form = {
          ...response.payload,
        };

        this.editing = true;
      } catch (ex) {
        let message = ex.errors.message;
        if (message == "No encontrado")
          message = Constants.Errors.RECORD_NOT_FOUND;
        Alert.error(message, () =>
          this.$router.push({ name: "tools-announcement-bar-list" })
        );
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  computed: {
    ...mapGetters({
      categoriesList: "app/getCategories",
    }),
    redirectSectionTitle: function () {
      let redirectTypes = this.LocalConstants.BannersRedirectTypes;
      return this.form.redirectType == redirectTypes.CATEGORY.key ||
        this.form.redirectType == redirectTypes.PRODUCT.key
        ? "Seleccione"
        : "Ingrese ruta";
    },
  },
  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus">
@import '../Styles/announcement-bar-form.styl';
</style>